import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./PrivacyPolicy.css";
import { Helmet } from "react-helmet-async";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Skilledition | Privacy Policy</title>
        <meta
          name="description"
          content="Skilledition Privacy Policy explains how we collect, use, and protect your personal data while you use our learning platform."
        />
        <link rel="canonical" href="https://skilledition.in/privacy-policy" />

        {/* Open Graph */}
        <meta property="og:title" content="Skilledition | Privacy Policy" />
        <meta
          property="og:description"
          content="Learn how Skilledition collects, uses, and safeguards your personal information on our platform."
        />
        <meta
          property="og:url"
          content="https://skilledition.in/privacy-policy"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://skilledition.in/seo-banner-privacy.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:title"
          content="Skilledition | Privacy Policy"
        />
        <meta
          name="twitter:description"
          content="Learn how Skilledition collects, uses, and safeguards your personal information on our platform."
        />
        <meta
          name="twitter:image"
          content="https://skilledition.in/seo-banner-privacy.png"
        />
      </Helmet>

      <section className="privacy-policy">
        <Container>
          <Row>
            <Col>
              <h2 className="privacy-policy-title">Privacy Policy</h2>
              <p className="privacy-policy-subtitle">
                At Skilledition, we value your trust and are
                committed to safeguarding your privacy. This Privacy Policy
                explains how we collect, use, and protect your personal
                information while you access and use our platform.
              </p>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <Card className="privacy-policy-card">
                <Card.Body>
                  <h4 className="privacy-policy-heading">
                    1. Information We Collect
                  </h4>
                  <p className="privacy-policy-text">
                    We may collect personal details such as your name, email
                    address, phone number, payment information, and academic
                    records. We also collect non-personal data like device
                    information, IP address, and browsing activity to enhance
                    your learning experience.
                  </p>

                  <h4 className="privacy-policy-heading">
                    2. How We Use Your Information
                  </h4>
                  <p className="privacy-policy-text">
                    Your information is used to provide access to courses, issue
                    certificates, process payments, and improve our services. We
                    may also send updates, notifications, and promotional offers
                    relevant to your learning journey at Skilledition.
                  </p>

                  <h4 className="privacy-policy-heading">
                    3. Data Protection & Security
                  </h4>
                  <p className="privacy-policy-text">
                    We implement strict security measures to protect your data
                    from unauthorized access, alteration, or disclosure.
                    However, while we strive for high security, no online system
                    is entirely risk-free.
                  </p>

                  <h4 className="privacy-policy-heading">
                    4. Sharing of Information
                  </h4>
                  <p className="privacy-policy-text">
                    We do not sell or rent your personal information. Data may
                    only be shared with trusted third-party service providers
                    (e.g., payment gateways, video platforms) strictly for
                    operational purposes.
                  </p>

                  <h4 className="privacy-policy-heading">
                    5. Cookies & Tracking
                  </h4>
                  <p className="privacy-policy-text">
                    Skilledition uses cookies to personalize your experience, analyze
                    usage trends, and improve platform performance. You can
                    manage or disable cookies through your browser settings.
                  </p>

                  <h4 className="privacy-policy-heading">6. Your Rights</h4>
                  <p className="privacy-policy-text">
                    You have the right to access, update, or delete your
                    personal information at any time. You may also opt out of
                    promotional communications by updating your preferences in
                    your account.
                  </p>

                  <h4 className="privacy-policy-heading">
                    7. Third-Party Links
                  </h4>
                  <p className="privacy-policy-text">
                    Our platform may include links to third-party websites or
                    tools. We are not responsible for their privacy practices,
                    so we encourage you to review their policies separately.
                  </p>

                  <h4 className="privacy-policy-heading">
                    8. Children’s Privacy
                  </h4>
                  <p className="privacy-policy-text">
                    Skilledition does not knowingly collect data from children
                    under the age of 13. If we become aware of such information,
                    we will take immediate steps to delete it.
                  </p>

                  <h4 className="privacy-policy-heading">9. Policy Updates</h4>
                  <p className="privacy-policy-text">
                    We may update this Privacy Policy from time to time.
                    Continued use of our platform after updates signifies your
                    acceptance of the revised terms.
                  </p>

                  <h4 className="privacy-policy-heading">10. Contact Us</h4>
                  <p className="privacy-policy-text">
                    If you have any questions or concerns regarding this Privacy
                    Policy, please contact us:
                    <br /> 📧 Email: info@skilledition.in
                    <br /> 📞 Phone: +91 8143 8796 27
                    <br /> 🏢 Address: Digisphere Tech Pvt. Ltd, Vijayawada,
                    India
                  </p>

                  <p className="privacy-policy-footer">
                    By using Skilledition, you acknowledge that you have read,
                    understood, and agreed to this Privacy Policy.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PrivacyPolicy;
